import unescapedText from 'I18n/utils/unescapedText';
import I18n from 'I18n';
/**
 * Returns data for the current user's locale according to MomentJS. It's important that this not
 * be called until I18n is ready. For UIComponents, this means waiting until render.
 */
export const getLocaleData = () => {
  const locale = (I18n.moment.locale || I18n.moment.lang)();
  return (I18n.moment.localeData || I18n.moment.langData)(locale);
};
export const getLocalizedDateFormat = format => {
  const longDateFormat = getLocaleData().longDateFormat(format) || format;
  return longDateFormat;
};
export const getDatePlaceholder = format => getLocalizedDateFormat(format).replace(/MM/, unescapedText('ui.datePicker.placeholder.month')).replace(/DD/, unescapedText('ui.datePicker.placeholder.day')).replace(/YYYY/, unescapedText('ui.datePicker.placeholder.year'));